import { BackendResponse } from "../BackendResponse";
import { NextApiParams, withNextApi } from "../nextApiHelpers";

export interface CancelEmailPendingProcessResponse extends BackendResponse {}
export interface CancelEmailPendingProcessParameters extends NextApiParams {}

export const cancelEmailPendingProcess = withNextApi<
  CancelEmailPendingProcessResponse,
  CancelEmailPendingProcessParameters
>("/cvp/CvpCancelEmailPendingProcess");
